module.exports = __webpack_public_path__ + "img/background-modal.b840835a.svg";